import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { userIdentityShape, ugcVideoShape, bibShape, shelfItemShape } from '@bibliocommons/bc-prop-types';
import VideoDisplay from '../../../shared/UGC/VideoDisplay';

export default class ShelfListItemVideoInfo extends React.PureComponent {
  render() {
    const {
      bib,
      item,
      owner,
      ownerVideoForBib,
      videosTransactions,
      shelfTransactions,
      videosActions,
      shelfActions
    } = this.props;

    if (ownerVideoForBib) {
      return (
        <div className="cp-shelf-list-item-video-info">
          <VideoDisplay
            bib={bib}
            shelfItem={item}
            video={ownerVideoForBib}
            owner={owner}
            videosTransactions={videosTransactions}
            shelfTransactions={shelfTransactions}
            videosActions={videosActions}
            shelfActions={shelfActions}
          />
        </div>
      );
    }

    return null;
  }
}

ShelfListItemVideoInfo.propTypes = {
  bib: bibShape.isRequired,
  item: shelfItemShape.isRequired,
  owner: userIdentityShape.isRequired,
  ownerVideoForBib: ugcVideoShape,
  videosTransactions: ImmutablePropTypes.map,
  videosActions: PropTypes.objectOf(PropTypes.func).isRequired,
  shelfTransactions: ImmutablePropTypes.map.isRequired,
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired
};
